<script>
import Imprint from './Imprint'
import text from '../assets/dse.html'

let Privacy = {...Imprint}

Privacy.data = () => {
	return {
		text: text
	}
}

export default Privacy
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue